// extracted by mini-css-extract-plugin
module.exports = {"toggleElement":"custom-toggle_toggleElement__2X-q5"};